import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, mergeMap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { secondaryQuotesWorkspaceTabsFetchedThunk } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.thunks';
import { workspaceTabsFetchFailed } from 'state/workspaces/workspace.actions';

export function fetchSecondaryQuoteWorkspaceTabsEpic(): EpicWithThunk {
  return (action$, _state$, { httpClient }) => {
    const { getAllTabDescriptions } = tabsApiConnector(httpClient, 'secondaryMarketQuotes');
    return action$.pipe(
      ofType('WORKSPACE_TABS_FETCH_REQUESTED'),
      filter(({ workspace }) => workspace === 'secondaryMarketQuotes'),
      mergeMap(({ tabFetchRequestId }) =>
        getAllTabDescriptions().pipe(
          mergeMap(({ tabs, activeTabId }) => {
            return of(secondaryQuotesWorkspaceTabsFetchedThunk(tabs, activeTabId, tabFetchRequestId));
          }),
          catchError((_: Error) => {
            return of(workspaceTabsFetchFailed('secondaryMarketQuotes', tabFetchRequestId));
          }),
        ),
      ),
    );
  };
}
